import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAppSelector } from '@/store';
import { ROUTES } from '@/utils/constants';

const ProtectedRoute = () => {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const user = useAppSelector((state) => state.auth.user);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  // Forced one-time onboarding for every approved employee (any role) -
  // see docs/decisions.md ADR-014.
  const needsOnboarding = user?.approvalStatus === 'approved' && !user.onboardingCompletedAt;
  if (needsOnboarding && location.pathname !== ROUTES.ONBOARDING) {
    return <Navigate to={ROUTES.ONBOARDING} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
